import { RevieweeFilterBar } from "@domains/reviews/client/components/reviewee-filters/RevieweeFilterBar.tsx";
import { useCallback, type ReactNode } from "react";
import { useAnalyticsFilters } from "../hooks/useAnalyticsFilters.ts";
import { type AnalyticsFilterDimension, AnalyticsFilterDimensions, useAnalyticsTracking } from "../hooks/useAnalyticsTracking.ts";
import { PeriodFilterButton } from "./PeriodFilterButton.tsx";
import { SeriesRowBadge } from "./SeriesRowBadge.tsx";

const TRACKED_DIMENSION: Record<string, AnalyticsFilterDimension> = {
    directManagers: AnalyticsFilterDimensions.DirectManagers,
    reportingLine: AnalyticsFilterDimensions.ReportingLines,
    segment: AnalyticsFilterDimensions.Segment,
    department: AnalyticsFilterDimensions.Department,
    gender: AnalyticsFilterDimensions.Gender,
    workLocation: AnalyticsFilterDimensions.WorkLocation,
    roleLevel: AnalyticsFilterDimensions.RoleLevel,
    jobTitle: AnalyticsFilterDimensions.JobTitle,
    tenure: AnalyticsFilterDimensions.Tenure,
    track: AnalyticsFilterDimensions.Track
};

export interface FilterBarProps {
    series?: {
        letter: string;
        swatchClassName: string;
        name: string;
    };
    trailingContent?: ReactNode;
}

export function FilterBar({ series, trailingContent }: FilterBarProps) {
    const { periodSelection, setPeriod, clearPeriod, hasActivePeriod } = useAnalyticsFilters();
    const { trackFilterApplied, trackFiltersCleared } = useAnalyticsTracking();

    const handleFilterApplied = useCallback((kind: string) => trackFilterApplied(TRACKED_DIMENSION[kind]), [trackFilterApplied]);

    const leadingContent = (
        <>
            {series && (
                <>
                    <SeriesRowBadge letter={series.letter} swatchClassName={series.swatchClassName} />
                    <span className="sr-only">{series.name}</span>
                </>
            )}

            <PeriodFilterButton period={periodSelection} onChange={setPeriod} />
        </>
    );

    return <RevieweeFilterBar leadingContent={leadingContent} trailingContent={trailingContent} onFilterApplied={handleFilterApplied} onFiltersCleared={trackFiltersCleared} onClearExtraFilters={clearPeriod} hasExtraActiveFilters={hasActivePeriod} />;
}
